import { ApiRequest, CreateParams } from '../baseService'

const BaseRoute = 'app/fav-expert-email'

function getPreview(
  filter: {
    filterText?: string
    specialistIds?: string[]
    caseManagerIds?: string[]
    companyIds?: string[]
    skipCount?: number
    maxResultCount?: number
  } = {}
) {
  const qs = CreateParams(filter)
  return ApiRequest.get(`${BaseRoute}/preview?${qs.join('&')}`)
}

function getPreviewEmail(caseManagerId) {
  return ApiRequest.get(`${BaseRoute}/preview/${caseManagerId}/email`)
}

function getRuns(filter: {
  filterText?: string
  runAtFrom?: string
  runAtTo?: string
  skipCount?: number
  maxResultCount?: number
}) {
  const qs = CreateParams(filter)
  return ApiRequest.get(`${BaseRoute}/runs?${qs.join('&')}`)
}

function getRunRecipients(runId, skipCount = 0, maxResultCount = 200) {
  const qs = CreateParams({ skipCount, maxResultCount })
  return ApiRequest.get(`${BaseRoute}/runs/${runId}/recipients?${qs.join('&')}`)
}

// Send the Top Provider Availability email to a single case manager immediately.
// If destinationEmail is provided, it overrides the CM's own email (test send).
function sendToCaseManager(caseManagerId, destinationEmail) {
  const qs = destinationEmail
    ? `?destinationEmail=${encodeURIComponent(destinationEmail)}`
    : ''
  return ApiRequest.post(`${BaseRoute}/preview/${caseManagerId}/send${qs}`)
}

const API = {
  getPreview,
  getPreviewEmail,
  getRuns,
  getRunRecipients,
  sendToCaseManager,
}

export default API
